import component from './en-US/component';
import globalHeader from './en-US/globalHeader';
import menu from './en-US/menu';
import pages from './en-US/pages';
import pwa from './en-US/pwa';
import settingDrawer from './en-US/settingDrawer';
import settings from './en-US/settings';

export default {
    'navBar.lang': 'Languages',
    'layout.user.link.help': 'Help',
    'layout.user.link.privacy': 'Privacy',
    'layout.user.link.terms': 'Terms',
    'app.preview.down.block': 'Download this page to your local project',
    'app.welcome.link.fetch-blocks': 'Get all block',
    'app.welcome.link.block-list': 'Quickly build standard, pages based on `block` development',
    ...globalHeader,
    ...menu,
    ...settingDrawer,
    ...settings,
    ...pwa,
    ...component,
    ...pages,
    // --- API & Interface Related ---
    'api.error.INVALID_APP_KEY': 'Invalid App Key',
    'api.error.APP_KEY_REQUIRED': 'App Key is required',
    'api.error.USER_DISABLED': 'Your account has been disabled. Please contact support.',
    'api.error.INTERNAL_SERVER_ERROR': 'Internal server error. Please try again later.',
    'api.error.USER_FROZEN': 'Account has been frozen. Please contact the administrator.',

    // --- Public Login & Auth ---
    'api.error.CAPTCHA_INCORRECT': 'Incorrect captcha',
    'api.error.CAPTCHA_GENERATE_FAILED': 'Failed to generate captcha',
    'api.error.LOGIN_PARAMS_ABNORMAL': 'Abnormal login parameters',
    'api.error.TOKEN_VERIFY_FAILED': 'Session expired. Please log in again.',
    'api.error.TOKEN_INVALID': 'Invalid authentication token',
    'api.error.TOKEN_SIGNATURE_INVALID': 'Token signature verification failed',
    'api.error.TOKEN_MISSING': 'No login status detected',
    'api.error.INVALID_CREDENTIALS': 'Invalid username or password',
    'api.error.TOKEN_GENERATION_FAILED': 'Failed to generate authentication token',

    // --- Account Status Related ---
    'api.error.ACCOUNT_NAME_REQUIRED': 'Account name is required',
    'api.error.BANK_CARD_NO_REQUIRED': 'Bank card number is required',
    'api.error.ACCOUNT_LIST_FETCH_FAILED': 'Failed to fetch account list',
    'api.error.INVALID_USER_ID': 'Invalid User ID',
    'api.error.USER_NOT_FOUND': 'User information not found',
    'api.error.USER_UPDATE_FAILED': 'Failed to update user information',
    'api.error.USER_CREATE_FAILED': 'Failed to create merchant account information',
    'api.error.ACCOUNT_DISABLED': 'This account has been disabled',
    'api.error.ACCOUNT_LOCKED': 'Account has been locked',
    'api.error.DELETE_USER_FAILED': 'Failed to delete account',
    'api.error.USER_HAS_REMAINING_BALANCE': 'Operation failed: Account still has a remaining balance',
    'api.error.USER_FETCH_FAILED': 'Failed to fetch user information',

    // --- Withdrawal & Transaction Business ---
    'api.error.UNSUPPORTED_WITHDRAW_METHOD': 'Unsupported withdrawal method',
    'api.error.INVALID_WITHDRAW_AMOUNT': 'Withdrawal amount must be greater than 0',
    'api.error.INVALID_PAY_PASSWORD': 'Incorrect payment password',
    'api.error.PAY_PASSWORD_NOT_SET': 'Payment password has not been set',
    'api.error.WITHDRAW_STATUS_DENY': 'Current account status is abnormal. Cannot initiate withdrawal.',
    'api.error.INSUFFICIENT_BALANCE': 'Insufficient available balance',
    'api.error.CREATE_WITHDRAW_RECORD_FAILED': 'Failed to create withdrawal record',
    'api.error.UPDATE_USER_BALANCE_FAILED': 'Failed to deduct account balance',
    'api.error.WRITE_FUND_LOG_FAILED': 'Failed to write fund transaction log',

    // --- Statistics & Reports ---
    'api.error.USER_DAILY_STATS_GET_TODAY_FAILED': 'Failed to fetch today\'s statistical data',
    'api.error.USER_DAILY_STATS_TODAY_DATA_NOT_FOUND': 'No statistical data available for today',
    'api.error.ORDER_LIST_QUERY_FAILED': 'Failed to query order data',

    // --- System Notifications & Announcements ---
    'api.error.UPDATE_NOTICE_FAILED': 'Failed to update read status',
    'api.error.NOTIFICATION_COUNT_FAILED': 'Failed to count notifications',
    'api.error.NOTIFICATION_QUERY_FAILED': 'Failed to query notification list',

    // --- Merchant Withdrawal Account Management ---
    'api.error.USERACCOUNT_NO': 'Withdrawal account does not exist',
    'api.error.USERACCOUNT_CREATE_FAILED': 'Failed to create withdrawal account',
    'api.error.USERACCOUNT_DELETE_FAILED': 'Failed to delete withdrawal account',
    'api.error.USERACCOUNT_COUNT_FAILED': 'Failed to count withdrawal accounts',
    'api.error.USERACCOUNT_QUERY_FAILED': 'Failed to query withdrawal account list',
    'api.error.USERACCOUNT_UPDATE_FAILED': 'Failed to update withdrawal account',
    'api.error.USERACCOUNT_PARAM_INVALID': 'Invalid account parameters',

    // --- General ---
    'api.error.PARAMS_ABNORMAL': 'Invalid request parameters',
};
